var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{staticClass:"dashboard-layout",attrs:{"fluid":"","pa-0":""}},[_c('app-header',{attrs:{"title":_vm.$route.meta.title,"logo-url":_vm.logoUrl,"is-visible":false}}),_vm._v(" "),_c('section',{staticClass:"dashboard-content"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c833830","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/layout-dashboard.vue
// module id = 1217
// module chunks = 115